module.exports = __webpack_public_path__ + "static/media/right-from-bracket-solid.56535628.png";